import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ItemService } from './item.service';

@Injectable()
export class ItemPopupService {
    private ngbModalRef: NgbModalRef;
    private releaseInfo: any;
    private templateId: number;
    private code: string;
    private companyId: number;
    private isViewSample = false;
    private isCheckXml: boolean;
    private data: any;

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private itemService: ItemService

    ) {
        this.ngbModalRef = null;
    }

    open(component: Component, id?: number | any): Promise<NgbModalRef> {
        return new Promise<NgbModalRef>((resolve, reject) => {
            const isOpen = this.ngbModalRef !== null;
            if (isOpen) {
                resolve(this.ngbModalRef);
            }
            if (id) {
                // this.itemService.getPdf(id, (objectUrl) => {
                    this.itemService.getReleaseInfo(id).subscribe((data) => {
                        this.releaseInfo = data;
                        setTimeout(() => {
                            this.ngbModalRef = this.modalRef(component, {
                                url: null
                            });
                            resolve(this.ngbModalRef);
                         }, 0);
                    });
                // });
            } else {
                // setTimeout used as a workaround for getting ExpressionChangedAfterItHasBeenCheckedError
                setTimeout(() => {
                    this.ngbModalRef = this.modalRef(component, {});
                    resolve(this.ngbModalRef);
                }, 0);
            }
        });
    }

    modalRef(component: Component, item: any): NgbModalRef {
        const modalRef = this.modalService.open(component, {
            size: 'lg',
            backdrop: true,
            windowClass: 'popup-preview'
        });
        modalRef.componentInstance.item = item;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.ngbModalRef = null;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.ngbModalRef = null;
        });
        return modalRef;
    }

    getReleaseInfo() {
        return this.releaseInfo;
    }

    getTemplateId() {
        return this.templateId;
    }
    
    getCode() {
        return this.code;
    }

    getCompanyId() {
        return this.companyId;
    }

    setIsViewSample(isView: boolean) {
        this.isViewSample = isView;
    }

    getIsViewSample(): boolean {
        return this.isViewSample;
    }

    
    setDataOfXml(invoiceMaster:any, InvoiceItems:any, invoiceBills: any, invoiceGifts: any, tempFileUpload:any, signature:any){
        this.data = {};
        this.data.invoiceMaster = invoiceMaster;
        this.data.InvoiceItems = InvoiceItems;
        this.data.invoiceBills = invoiceBills;
        this.data.invoiceGifts = invoiceGifts;
        this.data.tempFileUpload = tempFileUpload;
        this.data.signature = signature;
        
        this.setIsCheckXml(true);
    }

    getDataOfXml(){
        if(this.data != null && this.data != undefined){
            return this.data;
        }else{
            return {};
        }
    }
    setIsCheckXml(IsCheckXml: boolean){
        this.isCheckXml = IsCheckXml;
    }
    getIsCheckXml(){
        return this.isCheckXml;
    }
}
